export default __webpack_public_path__ + "static/media/homeseller-hero.b4b82790.jpg";